import React from "react";
import StructuredNav from "./StructuredNav";
import Backgrounds from "./Backgrounds";

const Home = () => {
  return (
    <div id="home">
      <StructuredNav />
      <Backgrounds />
    </div>
  );
};

export default Home;
